import { ACTIVITY_TYPES_ENUM, POST_READING } from './activity_types';

const EVIDENCE_TAGGING = 3;

export const maxAttemptsByType = {
  [ACTIVITY_TYPES_ENUM.GRAPHIC_ORGANIZER_TYPE]: 2,
  [ACTIVITY_TYPES_ENUM.EVIDENCE_TAG]: 3,
  [POST_READING]: 2,
};

export default { EVIDENCE_TAGGING };
